import * as ImageCompressor from '@xkeshi/image-compressor';

import { IMAGE_COMPRESSION_QUALITY, MAX_IMAGE_DIMENSION_IN_PIXELS, MAX_IMAGE_FILE_SIZE_IN_BYTES } from 'constants/image';

export function compress(input: File, successCallback: (result: File) => void, errorCallback: (error: Error) => void) {
  new ImageCompressor(input, { // tslint:disable-line
    convertSize: MAX_IMAGE_FILE_SIZE_IN_BYTES,
    maxHeight: MAX_IMAGE_DIMENSION_IN_PIXELS,
    maxWidth: MAX_IMAGE_DIMENSION_IN_PIXELS,
    quality: IMAGE_COMPRESSION_QUALITY,
    success(result: File) {
      successCallback(result);
    },
    error(error: Error) {
      errorCallback(error);
    }
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/image.ts